<template>
  <div class="image-div">
    <transition name="fade">
      <img :src="imageUrl" :alt="alt" class="im-fill-w" v-show="loaded" v-on:click="zoom" v-if="seen" />
    </transition>
    <div class="greybar" v-show="loaded">
        <div>
          <div class="a-name">{{ artist.formatted_name }}</div>
          <div>
            <small-button v-on:click="zoom">{{ $nippets.portfolio.view }}</small-button>
          </div>
        </div>
        <div class="likebox-holder"><like-box :imageId="image.image_id" /></div>
    </div>
  </div>
</template>

<script>
//import TransitionablePanel from '@/components/widgets/TransitionablePanel.vue'
import LikeBox from '@/components/buttons/LikeBox.vue'
import ViewablePanel from '@/mixins/ViewablePanel.js'

export default {
  mixins: [ ViewablePanel ],
  components: {
    LikeBox
  },
  props: {
    artist: Object,
    image: Object
  },
  data: function () {
    return {
      loaded: false
    }
  },
  created: function () {
    this.loaded = false
  },
  computed: {
    imageUrl: function () {
      if(this.image.swf) {
        if(this.image.swf.toLowerCase().endsWith('.gif')){
          return this.$k.imagebase + 'media/artist/' + this.artist.portfolio_url + '/' + this.image.swf
        }
      }
      return this.$k.getImage320(this.image.url)
    },
    alt: function () {
      if(this.image.alt) return this.image.alt
      if(this.image.detail) {
        if(this.image.detail.title) return this.image.detail.title
      }
      return this.artist.formatted_name
    }
  },
  methods: {
    loadImage: async function () {
      try {
        await this.$k.loadImage(this.imageUrl)
      }
      catch(err) {
        console.log('** unable to load', this.imageUrl)
      }
      this.loaded = true
    },
    zoom: async function () {
      this.$emit('click', this.image)
    }
  },
  watch: {
    seen () {
      this.loadImage()
    }
  }
}
</script>

<style scoped>
.a-name{
  margin-bottom:6px;
  padding-right:20px;
}

.image-div{
  position:relative;
  margin-bottom:5.5%;
  min-height:110px;
  overflow:hidden;
}

img.im-fill-w{
  width:100%;
  height:auto;
  display:block;
  min-height:100px;
  cursor:pointer;
  transition:all 0.4s ease;
}

.image-div:hover img.im-fill-w{
  transform:scale(1.04);
}

.greybar{
  position:absolute;
  transition:all 0.3s ease;
  bottom:0;
  left:0;
  width:100%;
  box-sizing:border-box;
  transform: translateY(100%);
}

.image-div:hover .greybar{
  transform:none;
}



</style>
